import { cn } from "@app/util/helpers";
import { SanitizedPulseData } from "@features/pulse/utils/types";
import { CARD_WIDTH } from "@features/pulse/variant/others/utils/constants";
import { motion } from "motion/react";

type PulseDesktopCarouselProgressBarProps = {
  /** Index of the active article card */
  activeArticle: number;
  /** List of articles to be displayed in the progress bar */
  sortedPulseArticles: SanitizedPulseData[];
};

/** Progress bar for pulse variant manual */
const PulseDesktopCarouselProgressBar = ({
  activeArticle,
  sortedPulseArticles,
}: PulseDesktopCarouselProgressBarProps): React.ReactElement => {
  const width = Math.round((activeArticle / sortedPulseArticles.length) * 100);

  return (
    <div
      className="relative mx-auto h-[5px] rounded-[7px] bg-white/10"
      style={{
        width: `${CARD_WIDTH}px`,
      }}
      data-testid="pulse-desktop-carousel-progress-bar-component"
    >
      <motion.div
        className={cn("h-full rounded-l-[7px] bg-pulseProgress", {
          "rounded-r-[7px]": activeArticle === sortedPulseArticles.length,
        })}
        animate={{
          width: `${width}%`,
        }}
      ></motion.div>

      <motion.div
        className="absolute -top-[7px] aspect-square h-5 rounded-full bg-[#5161B666] blur-[6px]"
        animate={{
          left: `${width - 2}%`,
        }}
      ></motion.div>
    </div>
  );
};

export default PulseDesktopCarouselProgressBar;
